var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"preserveAspectRatio":"none"}})
}
var staticRenderFns = []

export { render, staticRenderFns }